import { FC, useMemo } from "react"
import { Button, ButtonProps, useTheme } from "@mui/material"

import { ListIcon } from "components/icons"
import { useTranslation } from "providers/i18n"
import { getIcon } from "utils/icon"

interface IStepButtonProps extends ButtonProps {
  label?: string
}

export const StepButton: FC<IStepButtonProps> = ({
  label = "Step",
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const icon = useMemo(
    () => getIcon(theme?.assets?.navigation?.step) || <ListIcon />,
    [theme]
  )

  return (
    <Button variant="outlined" startIcon={icon} {...props}>
      {t(label)}
    </Button>
  )
}
